import React from "react"
import ReactSelect from "react-select"

import { Label } from "../../components/shared/Inputs"
import { getGroupedTimezoneOptions } from "../../utils/timeZoneUtils"
import { selectStyling } from "../../utils/utils"

// Shared time zone picker used by every location kind (office, home, virtual).
// Before this existed, only virtual locations had a tz picker, which meant an
// auto-detected (and sometimes wrong) time zone on an office/home location was
// invisible and uncorrectable to the pro — the mechanism behind the
// practice-780 regression and the 15 mis-configured EU locations surfaced by
// `rake timezone:audit_mismatched`.
const LocationTimeZoneField = ({ location, setLocation, helperText }) => {
  const [timeUpdate, setTimeUpdate] = React.useState(0)

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimeUpdate((prev) => prev + 1)
    }, 30000)
    return () => clearInterval(interval)
  }, [])

  const timezoneOptions = React.useMemo(() => getGroupedTimezoneOptions(), [timeUpdate])

  const selectedOption = location.timeZone
    ? timezoneOptions
        .flatMap((group) => group.options)
        .find((tz) => tz.label === location.timeZone || tz.value === location.timeZone) || null
    : null

  return (
    <div className="flex flex-col gap-2">
      <Label>Time Zone</Label>
      <ReactSelect
        id="timezone-select"
        options={timezoneOptions}
        value={selectedOption}
        onChange={(option) => setLocation({ ...location, timeZone: option?.value || option?.label })}
        styles={{
          ...selectStyling(),
          option: (provided, state) => ({
            ...provided,
            display: "flex",
            justifyContent: "space-between",
            "&:after": {
              content: `"${state.data.currentTime}"`,
              color: "#666"
            }
          }),
          group: (provided) => ({
            ...provided,
            padding: "8px"
          })
        }}
        formatGroupLabel={(group) => <div className="font-semibold text-gray-dark">{group.label}</div>}
        placeholder="Select a time zone..."
      />
      {helperText && <p className="text-xs text-gray-dark-light">{helperText}</p>}
    </div>
  )
}

export default LocationTimeZoneField
